
import { inventoryManagementURl } from '@/app/inventory-management/shared/inventory-management-URLs.js';
import { FinanceURl } from '@/app/finance/shared/finance-URL.js';
import { DentalURl } from '@/app/dental/shared/dental-URL.js';
import { PharmacyURl } from '@/app/pharmacy/shared/pharmacy-URL.js';
import { BloodBankURL } from '@/app/blood-bank/shared/blood-bank-URL.js';
import { CPGURL } from '@/app/clinical-practice-guideline/shared/clinical-practice-guideline-URLs.js';
import { LabRadURL } from '@/app/lab-rad/shared/lab-rad-URLs.js';
import { PatientSearchURL } from '@/app/shared/layouts/services/searchPatientUrls.js';
import { PatientProblemURl } from '@/app/patient-problems/shared/patient-problems-URLs.js';
import { VisitManagementURl } from '@/app/visit-management/shared/visitManagement-URL';
import { CpoeURl } from '@/app/cpoe/shared/cpoe-URLs.js';
import { ClinicalNotesURL } from '@/app/configurations/shared/configurations-URLs.js';
import { HospitalStructureURL } from '@/app/hospital-structure/shared/HospitalStructureURLs.js'
import { BedManagmentURL } from '@/app/hospital-structure/shared/BedManagmentURLs.js'
import { MedicalRecordsURl } from '@/app/medical-records/shared/medical-records-URLs.js'
import { OutpatientURL } from '@/app/outpatient/shared/outpatient-URL.js'
import { QueuingManagementURL } from '@/app/queuing-management/shared/queuing-management-URL.js';
import { MedicationAdministrationURl } from '@/app/medication-administration/shared/medication-administration-URLs.js';
import { NotificationUrl } from '@/app/shared/layouts/services/notification-url.js';

import { appLocalStorage } from '@/app/shared/commonURLs';
import { BillingManagementURL } from '@/app/billing-management/shared/billing-management-URL.js';
import { ScreeningURl } from '@/app/screening/shared/screening-URL.js';
import { ScreeningModuleURL } from '@/app/shared/components/health-questionnaire/services/url/screening-URL';
import { MedicalHistoryModuleURL } from '@/app/shared/components/health-questionnaire/services/url/MedicalHistory-URL';
import { ProductManagementURL } from '@/app/product-management/shared/product-management-URL.js';
import { MilkBankURL } from '@/app/milk-bank/shared/milk-bank-URL.js';


let inventoryManagementServicesList = inventoryManagementURl.inventoryManagementServicesList;
let inventoryManagementOdataServicesList = inventoryManagementURl.inventoryManagementOdataServiceList;
let visitManagementOdataServicesList = inventoryManagementURl.visitManagementOdataServiceList;
let financeServicesList = FinanceURl.FinanceServicesList;
let dentalServicesList = DentalURl.DentalServicesList;
let pharmacyServicesList = PharmacyURl.pharmacyServicesList;
let financeODataServicesList = FinanceURl.FinanceServicesList;
let supplayChainInFinanceList = FinanceURl.SupplyChainServicesList;
let BillingInFinanceList = FinanceURl.BillingServicesList;

let BillingMgtList = BillingManagementURL.BillingManagementServiceList;
let BillingMgtODataServicesList = BillingManagementURL.BillingOdataServiceList;

//////// product management (pmgt)
let ProductMgtList = ProductManagementURL.ProductManagementServiceList;
let ProductMgtODataServicesList = ProductManagementURL.ProductOdataServiceList;

//// Supply Chain

// START BLOOD BANK MODULE VARIABLES

let bloodBankServicesList = BloodBankURL.BloodBankServicesList;
let bloodBankODataServicesList = BloodBankURL.BloodBankServicesList;
let supplayChainInBloodBankList = BloodBankURL.SupplyChainServicesList;
let labRadInBloodBankList = BloodBankURL.LabRadServicesList;
let visitMgtInBloodBankList = BloodBankURL.VisitMgtServicesList;
let milkBankServicesList = MilkBankURL.MilkBankServicesList;
let milkBankODataServicesList = MilkBankURL.MilkBankServicesList;

// END BLOOD BANK MODULE VARIABLES

// START BLOOD BANK MODULE VARIABLES

let patientProblemServicesList = PatientProblemURl.PatientProblemServicesList;
let patientProblemOdataServicesList = PatientProblemURl.PatientProblemServicesList;

// END BLOOD BANK MODULE VARIABLES
let MPIODataServicesList = PatientSearchURL.PatientSearchServicesList;

let CpoeODataServicesList = BloodBankURL.CpoeServicesList;
let PmgtServicesList = BloodBankURL.PmgtServicesList;


let cpgServicesList = CPGURL.CPGServicesList;
let PatientProblemServiceList = CPGURL.PatinetProblemServicesList;
let cpgPmgtServicesList = CPGURL.PmgtServicesList;
let cpgMedicalServiceList = CPGURL.cpgMedicalServiceList;
let VMdataServiceList = VisitManagementURl.VMServicesList;
let CPOEServiceList = CpoeURl.CpoeServicesList;
let CPOEForPPServiceList = PatientProblemURl.CpoeServicesList;
let ClinicalNotesServicesList12 = ClinicalNotesURL.ClinicalNotesServicesList;
let CpoeConfigurationServicesList = ClinicalNotesURL.CPOEConfigurationServicesList;
let HospitalStructureServiceList = HospitalStructureURL.HospitalStructureServiceList;
let HSMedicalSetupServiceList = HospitalStructureURL.HSMedicalSetupServiceList;

let BedManagmentServiceList = BedManagmentURL.BedManagmentServiceList;

let MedicalRecordsServiceList = MedicalRecordsURl.MedicalRecordsServiceList;
let OutPatientServiceList = OutpatientURL.OutPatientServiceList;

let QueuingManagementServicesList = QueuingManagementURL.QueuingManagementServicesList;
let QueuingManagementODataServicesList = QueuingManagementURL.QueuingManagementServicesList;

let LabRadServiceList = LabRadURL.LabRadServiceList;

let MedicationAdministrationServicesList = MedicationAdministrationURl.MedicationAdministrationServicesList;

let CpoeInMedicationAdminstrationServiceList = MedicationAdministrationURl.CpoeServicesList;

let PmgtInMedicationAdminstrationServiceList = MedicationAdministrationURl.PmgtServicesList;
let SupplyChainInMedicationAdminstrationServiceList = MedicationAdministrationURl.SupplyChainServicesList;
let SecurityInMedicationAdminstrationServiceList = MedicationAdministrationURl.SecurityServiceList;

let NotificationServiceList = NotificationUrl.NotificationServicesList;
let NotificationWebSocketServiceList = NotificationUrl.BONotificationWebSocketList;
let ScreeningServiceList = ScreeningURl.ScreeningServiceList;
let ScreeningModuleServiceList = ScreeningModuleURL.screeningServicesList;
let MedicalHistoryModuleServiceList = MedicalHistoryModuleURL.MedicalHistoryServicesList;

//// Supply Chain
export class services {
    constructor() {
        this.baseUrl = appLocalStorage.baseUrl;
        this.dentalUrl = appLocalStorage.DentalBaseUrl;
        this.bloodBankUrl = appLocalStorage.BloodBankBaseUrl;
    }
    getAnalyzerServiceName(serviceName) {
        return getAnalyzerService(serviceName);
    }
    getOrganismServiceName(serviceName) {
        return getOrganismService(serviceName);
    }
    getAnalyzerProductsServiceName(serviceName) {
        return getAnalyzerProductsService(serviceName);
    }

    PostAnalyzerServiceName(serviceName) {
        return PostAnalyzerService(serviceName);
    }
    PostUpdatedAnalyzerServiceName(serviceName) {
        return PostUpdatedAnalyzerService(serviceName);
    }
    PostUpdatedAnalyzerProdServiceName(serviceName) {
        return PostUpdatedAnalyzerProdService(serviceName);
    }
    PostAssignedAsDefaultBeforeServiceName(serviceName) {
        return PostAssignedAsDefaultBeforeService(serviceName);
    }
    PostAnalyzerProductServiceName(serviceName) {
        return PostAnalyzerProductService(serviceName);
    }
    getAnalyzerStatusServiceName(serviceName) {
        return getAnalyzerStatusService(serviceName);
    }
    getAnalyzerTranfareTypesServiceName(serviceName) {
        return getAnalyzerTranfareTypesService(serviceName);
    }
    getInventoryManagementServiceName(serviceName) {
        return getInventoryManagementService(serviceName);
    }
    getInventoryManagementOdataServiceName(serviceName) {
        return getInventoryManagementOdataService(serviceName);
    }
    getVisitManagementOdataServiceName(serviceName) {
        return getVisitManagementOdataService(serviceName);
    }
    getDataCacheFromLocalStore(key) {
        return getDataCache(key)
    }

    getFinanceServiceName(serviceName) {

        return getFinanceService(serviceName);
    }
    getBillingServiceName(serviceName) {
        return getBillingServiceForFinance(serviceName);
    }
    getDentalServiceName(serviceName) {

        return getDentalService(serviceName);
    }
    getPharmacyServiceName(serviceName) {

        return getPharmacyService(serviceName);
    }
    getFinanceOdataServiceName(serviceName) {
        return getFinanceOdataServic(serviceName);
    }
    getgSupplyChainServiceForFinanceName(serviceName) {
        return getSupplyChainServiceForFinance(serviceName);
    }
    ifUserHasPermission(actionName, route) {
        return checkUserPermission(actionName, route)
    }
    isAuthenticated() {
        return checkUserAuthenticated();
    }
    getBloodBankOdataServiceName(serviceName) {
        return getBloodBankOdataService(serviceName);
    }
    getBloodBankServiceName(serviceName) {
        return getBloodBankService(serviceName)
    }
    getCpoeOdataServiceName(serviceName) {
        return getCpoeOdataService(serviceName);
    }
    getMPIOdataServiceName(serviceName) {
        return getMPIOdataService(serviceName);
    }
    getPmgtServiceName(serviceName) {
        return getPmgtService(serviceName);
    }
    getOrderLineInstanceResultsServiceName(serviceName) {
        return getOrderLineInstanceResultsService(serviceName);
    }
    getCPGPmgtServiceName(serviceName) {
        return getCPGPmgtService(serviceName);
    }
    getLRPmgtServiceName(serviceName) {
        return getLRPmgtService(serviceName);
    }
    getCPGServiceName(serviceName) {
        return getCPGService(serviceName)
    }
    getCPGCategoriesServiceName(serviceName) {
        return getCPGCategoriesService(serviceName)
    }
    getPatientProblemServiceName(serviceName) {
        return getPatientProblemService(serviceName)
    }
    GetMdicalSetupServiceName(serviceName) {
        return getCPGMedicalService(serviceName)
    }
    getSupplyChainServiceForBloodBankName(serviceName) {

        return getSupplyChainServiceForBloodBank(serviceName);
    }
    getLabRadServiceForBloodBankName(serviceName) {
        return getLabRadServiceForBloodBank(serviceName);
    }
    getVisitMgtForBloodBankListName(serviceName) {
        return getVisitMgtForBloodBankList(serviceName);
    }
    addDataSessionCache(actionName, route) {

        return addDataSessionCache(actionName, route)
    }
    clearDataSessionCache(actionName, route) {
        return clearDataSessionCache(actionName, route)
    }
    getPatientProblemsOdataServiceName(serviceName) {
        return getPatientProblemsOdataService(serviceName);
    }
    getPatientProblemsServiceName(serviceName) {
        return getPatientProblemsService(serviceName)
    }

    getVMServiceName(serviceName) {
        return getVMService(serviceName)
    }
    getCPOEServiceName(serviceName) {
        return getCPOEService(serviceName);
    }

    getCPOEForPPServiceName(serviceName) {
        return getCPOEForPPService(serviceName);
    }

    getClinicalNotesServiceName(serviceName) {
        return getClinicalNotesService(serviceName);
    }
    getCPOEConfigurationServiceName(serviceName) {
        return getCPOEConfiurationService(serviceName);
    }
    getHospitalStructureServiceName(serviceName) {
        return getHospitalStructureService(serviceName);
    }

    getHSMedicalSetupServiceName(serviceName) {
        return getHSMedicalSetupService(serviceName);
    }

    getBedManagmentServiceName(serviceName) {
        return getBedManagmentService(serviceName);
    }

    getMedicalRecordsServiceName(serviceName) {
        return getMedicalRecordsService(serviceName);
    }

    getOutPatientServiceName(serviceName) {
        return getOutPatientService(serviceName);
    }
    getQueuingManagementOdataServiceName(serviceName) {
        return getQueuingManagementOdataService(serviceName);
    }
    getQueuingManagementServiceName(serviceName) {
        return getQueuingManagementService(serviceName)
    }

    getLabRadServiceName(serviceName) {
        return getLabRadService(serviceName)
    }

    getMedicationAdministrationServiceName(serviceName) {
        return getMedicationAdministrationService(serviceName);
    }

    getCPOEForMedicationAdminstrationServiceName(serviceName) {
        return getCPOEForMedicationAdminstrationService(serviceName);
    }

    getPmgtForMedicationAdminstrationServiceName(serviceName) {
        return getPmgtForMedicationAdminstrationService(serviceName);
    }

    getSupplyChainForMedicationAdminstrationServiceName(serviceName) {
        return getSupplyChainForMedicationAdminstrationService(serviceName);
    }
    getSecurityForMedicationAdminstrationServiceName(serviceName) {
        return getSecurityForMedicationAdminstrationService(serviceName);
    }

    getNotificationServiceName(serviceName) {
        return getNotificationService(serviceName);
    }

    getNotificationWebSocketServiceName(serviceName) {
        return getNotificationWebSocketService(serviceName);
    }
    getBillingMgtServiceName(serviceName) {
        return getBillingMgtService(serviceName);
    }
    getBillingMgtODataServiceName(serviceName) {
        return getBillingMgtODataService(serviceName);
    }

    getProductMgtServiceName(serviceName) {
        return getProductMgtService(serviceName);
    }
    getProductMgtODataServiceName(serviceName) {
        return getProductMgtODataService(serviceName);
    }

    getScreeningServiceName(serviceName) {
        //debugger;
        return getScreeningService(serviceName);
    }

    getScreeningModuleSeviceName(seviceName) {
        return getScreeningModuleSevice(seviceName);
    }

    getMedicalHistoryModuleSeviceName(seviceName) {
        return getMedicalHistoryModuleSevice(seviceName);
    }

    getMilkBankServiceName(serviceName) {
        return getMilkBankService(serviceName)

    }

    getMilkBankODataServiceName(serviceName) {
        return getMilkBankODataService(serviceName);
    }


}

const modelServices = new services();

export { modelServices };


function getInventoryManagementService(serviceName) {
    return inventoryManagementServicesList[serviceName];
}
function getInventoryManagementOdataService(serviceName) {
    return inventoryManagementOdataServicesList[serviceName];
}
function getVisitManagementOdataService(serviceName) {
    return visitManagementOdataServicesList[serviceName];
}
function getFinanceService(serviceName) {
    return financeServicesList[serviceName];
}
function getAnalyzerService(serviceName) {
    return LabRadServiceList[serviceName];
}
function getOrganismService(serviceName) {
    return LabRadServiceList[serviceName];
}

function getAnalyzerProductsService(serviceName) {
    return LabRadServiceList[serviceName];
}

function PostAnalyzerService(serviceName) {
    return LabRadServiceList[serviceName];
}
function PostAnalyzerProductService(serviceName) {
    return LabRadServiceList[serviceName];
}

function PostUpdatedAnalyzerService(serviceName) {
    return LabRadServiceList[serviceName];
}
function PostUpdatedAnalyzerProdService(serviceName) {
    return LabRadServiceList[serviceName];
}
function PostAssignedAsDefaultBeforeService(serviceName) {
    return LabRadServiceList[serviceName];
}

function getAnalyzerStatusService(serviceName) {
    return LabRadServiceList[serviceName];
}
function getOrderLineInstanceResultsService(serviceName) {
    return CPOEServiceList[serviceName];
}



function getAnalyzerTranfareTypesService(serviceName) {
    return LabRadServiceList[serviceName];
}

										  

												  
//	function getLRPmgtService(serviceName) {
//    return LabRadServiceList[serviceName];
//}									  
function getDentalService(serviceName) {
    return dentalServicesList[serviceName];
}
function getPharmacyService(serviceName) {
    return pharmacyServicesList[serviceName];
}
function getFinanceOdataServic(serviceName) {
    return financeODataServicesList[serviceName];
}
function getSupplyChainServiceForFinance(serviceName) {
    return supplayChainInFinanceList[serviceName];
}
function getBillingServiceForFinance(serviceName) {
    return BillingInFinanceList[serviceName];
}
function getBloodBankService(serviceName) {
    return bloodBankServicesList[serviceName];
}
function getBloodBankOdataService(serviceName) {
    return bloodBankODataServicesList[serviceName];
}
function getCpoeOdataService(serviceName) {
    return CpoeODataServicesList[serviceName];
}
function getMPIOdataService(serviceName) {
    return MPIODataServicesList[serviceName];
}
function getPmgtService(serviceName) {
    return PmgtServicesList[serviceName];
}

function getCPGPmgtService(serviceName) {
    return cpgPmgtServicesList[serviceName];
}
function getLRPmgtService(serviceName) {
    return LabRadServiceList[serviceName];
}
function getCPGService(serviceName) {
    return cpgServicesList[serviceName];
}
function getCPGCategoriesService(serviceName) {
    return cpgServicesList[serviceName];
}
function getLabRadService(serviceName) {
    return LabRadServiceList[serviceName]
}

function getSupplyChainServiceForBloodBank(serviceName) {
    return supplayChainInBloodBankList[serviceName]
}

function getVisitMgtForBloodBankList(serviceName) {
    return visitMgtInBloodBankList[serviceName]
}

function getLabRadServiceForBloodBank(serviceName) {
    return labRadInBloodBankList[serviceName];
}

function getPatientProblemService(serviceName) {

    return PatientProblemServiceList[serviceName];
}

function getCPGMedicalService(serviceName) {
    return cpgMedicalServiceList[serviceName];
}

function getPatientProblemsService(serviceName) {
    return patientProblemServicesList[serviceName];
}
function getPatientProblemsOdataService(serviceName) {
    return patientProblemOdataServicesList[serviceName];
}

function getVMService(serviceName) {

    return VMdataServiceList[serviceName];
}

function getCPOEService(serviceName) {
    return CPOEServiceList[serviceName];
}

function getCPOEForPPService(serviceName) {
    return CPOEForPPServiceList[serviceName];
}

function getClinicalNotesService(serviceName) {
    return ClinicalNotesServicesList12[serviceName];
}
function getCPOEConfiurationService(serviceName) {
    return CpoeConfigurationServicesList[serviceName];
}
function getHospitalStructureService(serviceName) {
    return HospitalStructureServiceList[serviceName];
}
function getHSMedicalSetupService(serviceName) {
    return HSMedicalSetupServiceList[serviceName];
}
function getBedManagmentService(serviceName) {
    return BedManagmentServiceList[serviceName];
}

function getMedicalRecordsService(serviceName) {
    return MedicalRecordsServiceList[serviceName];
}
function getOutPatientService(serviceName) {
    return OutPatientServiceList[serviceName];
}
function getQueuingManagementService(serviceName) {
    return QueuingManagementServicesList[serviceName];
}
function getQueuingManagementOdataService(serviceName) {
    return QueuingManagementODataServicesList[serviceName];
}

function getMedicationAdministrationService(serviceName) {
    return MedicationAdministrationServicesList[serviceName];
}

function getCPOEForMedicationAdminstrationService(serviceName) {
    return CpoeInMedicationAdminstrationServiceList[serviceName]
}

function getPmgtForMedicationAdminstrationService(serviceName) {
    return PmgtInMedicationAdminstrationServiceList[serviceName]
}

function getSupplyChainForMedicationAdminstrationService(serviceName) {
    return SupplyChainInMedicationAdminstrationServiceList[serviceName]
}
function getSecurityForMedicationAdminstrationService(serviceName) {
    return SecurityInMedicationAdminstrationServiceList[serviceName]
}

function getNotificationService(serviceName) {
    return NotificationServiceList[serviceName];
}

function getNotificationWebSocketService(serviceName) {
    return NotificationWebSocketServiceList[serviceName];
}

function getBillingMgtService(serviceName) {
    return BillingMgtList[serviceName];
}
function getBillingMgtODataService(serviceName) {
    return BillingMgtODataServicesList[serviceName];
}
function getProductMgtService(serviceName) {
    return ProductMgtList[serviceName];
}
function getProductMgtODataService(serviceName) {
    return ProductMgtODataServicesList[serviceName];
}

function getMilkBankService(serviceName) {
    return milkBankServicesList[serviceName];
}

function getMilkBankODataService(serviceName) {
    return milkBankODataServicesList[serviceName];
}

//get data cache
function getDataCache(key) {
    //get Value from local Storage
    var value = localStorage.getItem(key);
    //if doesnot exist then return
    if (!value) { return null; }
    // assume it is an object that has been stringified
    if (value[0] === "{" || value[0] === "[") {
        value = JSON.parse(value);
    }
    return value;
}

// function addDataCache(key, data) {
//    //check if key and data has value
//    if (!key || !data) { return; }
//    //incase of data is an object then stringify it 
//    if (typeof data === "object") {
//        data = JSON.stringify(data);
//    }
//    //set key and data in Local Storage
//    localStorage.setItem(key, data);
// }

// function clearLocalStorage() {
//    localStorage.clear();
// }

//add data cache
function addDataSessionCache(key, data) {

    //check if key and data has value
    if (!key || !data) { return; }
    //incase of data is an object then stringify it 
    if (typeof data === "object") {
        data = JSON.stringify(data);
    }
    //set key and data in Local Storage
    // localStorage.setItem(key, data);
    sessionStorage.setItem(key, data);
}

//clear session data cache
function clearDataSessionCache(key) {
    //Remove local Storage Item
    sessionStorage.removeItem(key);
}
function checkUserPermission(actionName, route) {
    let dataFromStorage = getDataCache("perms");
    return (dataFromStorage.filter(item => item.ClientActionName != null && item.ClientActionName === actionName && item.PageURL === route)).length > 0 ? true : false;
}

function checkUserAuthenticated() {
    let displayName = getDataCache("DisplayName");
    if (displayName != null) {
        return true;
    }
    return false;
}

function getScreeningService(serviceName) {
    return ScreeningServiceList[serviceName];
}


function getScreeningModuleSevice(serviceName) {
    return ScreeningModuleServiceList[serviceName];
}

function getMedicalHistoryModuleSevice(serviceName) {
    return MedicalHistoryModuleServiceList[serviceName];
}